import React from 'react';
import { useSearchInput } from '../hooks/useSearchInput';

const SearchInput = React.memo(({ 
  placeholder, 
  onCitySelect,
  backendUrl 
}) => {
  const {
    inputValue,
    municipalities,
    showDropdown,
    isLoading,
    inputRef,
    handleInputChange,
    selectMunicipality,
    clearInput
  } = useSearchInput(backendUrl);

  // console.log('🔄 SearchInput render:', inputValue, 'dropdown:', showDropdown);

  const handleChange = (e) => {
    handleInputChange(e.target.value);
  };

  const handleMunicipalityClick = (municipality) => {
    const cityName = selectMunicipality(municipality);
    if (onCitySelect) {
      onCitySelect(cityName);
    }
  };

  return (
    <div className="relative flex-1 min-w-[200px]">
      <input 
        ref={inputRef}
        type="text"
        value={inputValue}
        onChange={handleChange}
        placeholder={placeholder}
        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-gray-700"
        autoComplete="off"
      />
      
      {isLoading && (
        <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
          <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-500"></div>
        </div>
      )}
      
      {showDropdown && municipalities.length > 0 && (
        <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto">
          {municipalities.map(municipality => (
            <div 
              key={municipality.id}
              onClick={() => handleMunicipalityClick(municipality)}
              className="px-4 py-2 hover:bg-blue-50 cursor-pointer border-b border-gray-100 last:border-b-0"
            >
              <div className="font-medium text-gray-800">{municipality.name}</div>
              <div className="text-xs text-gray-500">{municipality.county}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
});


export default SearchInput;
